import React, { useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router";
import axios from "axios";
import moment from "moment";

import { IoIosMore } from "react-icons/io";
import { RiArrowGoBackFill, RiShareBoxFill } from "react-icons/ri";
import { AiOutlineClose } from "react-icons/ai";

import { isOutsideCmpny } from "../function/common";
import { keysToRemove, transformTodo } from "../function/common";
import useOutsideClick from "../../../../../hooks/useOutsideClick";
import { DetailInfoContaienr } from "../styled/scheduler";

const Info = ({
  isSchedule,
  setActive,
  active,
  eventInfo,
  openModal,
  closeModal,
  todos,
  submitDelete,
  exitSchedule,
  getEvent,
  setEventInfo,
  navigation,
  comments,
}) => {
  const { id } = useParams();

  const navigate = useNavigate();
  const location = useLocation();

  const user = useSelector((state) => state?.user?.data[0]);
  const company = useSelector((state) => state?.company?.data);
  const { isDarkMode } = useSelector((state) => state.scheduler);

  const contextRef = useRef();
  const [isContext, setIsContext] = useState(false);

  const isShared =
    eventInfo.gbn === "P" &&
    (String(eventInfo.mberNo) !== String(user.mberNo) ||
      Object.keys(eventInfo.workerList || {})
        .map(String)
        .includes(String(user.mberNo)));

  useOutsideClick(contextRef, () => {
    setIsContext(false);
  });

  const isMemoFilled = (memo) => {
    if (!memo) return false;
    const cleanedMemo = memo.normalize("NFKD").replace(/[\s\uFEFF\xA0\uFFFD\uFFFF]+/g, "");
    return cleanedMemo.length > 0;
  };

  const context = [
    {
      render: !isOutsideCmpny(eventInfo, company),
      name: "완료",
      action: () => eventComplete(),
    },
    {
      render: true,
      name: "복사",
      action: () => {
        const hasValidTodos = todos && todos.length && todos.some((todo) => !!todo.id);

        if (isMemoFilled(eventInfo.memo) || hasValidTodos) {
          openModal({
            isOpen: true,
            type: "confirmation",
            title: `메모 복사`,
            message: [`일정의 메모를 복사하시겠습니까?`],
            handleConfirm: () => eventCopy(eventInfo, true),
            handleCancel: () => eventCopy(eventInfo),
          });
        } else {
          eventCopy({ ...eventInfo });
        }
      },
    },
    {
      render: true,
      name: "공유",
      action: () => shareEvent(eventInfo, 117499),
    },
    {
      render: !isOutsideCmpny(eventInfo, company),
      name: "수정",
      action: () =>
        navigate(isSchedule ? "/mypage/scheduler/form" : "/mypage/scheduler/dday", {
          state: {
            eventInfo,
            todoInfo: isSchedule ? transformTodo(todos) : null,
            path: `/mypage/detailEvent/${id}`,
            navState: { ...(location?.state || {}) },
          },
        }),
    },
    isShared
      ? {
          render: true,
          name: "나가기",
          action: () =>
            openModal({
              isOpen: true,
              type: "confirmation",
              title: `나가기`,
              message: [`일정을 나가시겠습니까?`],
              handleConfirm: () => exitSchedule(eventInfo),
              handleCancel: () => closeModal(),
            }),
        }
      : {
          render: !isOutsideCmpny(eventInfo, company),
          name: "삭제",
          action: () =>
            openModal({
              isOpen: true,
              type: "confirmation",
              title: `${isSchedule ? "일정" : "디데이"} 삭제`,
              message: [`${isSchedule ? "일정을" : "디데이를"} 삭제하시겠습니까?`],
              handleConfirm: () => submitDelete(eventInfo),
              handleCancel: () => closeModal(),
            }),
        },
  ];

  // 일정 복사
  const eventCopy = async (event, flag = false) => {
    const startMoment = moment(event.startDt);
    const endMoment = moment(event.endDt);

    const duration = moment.duration(endMoment.diff(startMoment));

    const today = moment();
    const newStart = today.set({
      hour: startMoment.hour(),
      minute: startMoment.minute(),
      second: startMoment.second(),
    });

    const newEnd = moment(newStart).add(duration);

    const isPersonal = eventInfo.gbn === "P";
    const item = keysToRemove(event, ["completeYn", "mberNo", "scheduleNo"]);

    let body = {
      ...item,
      start: moment(newStart).format("YYYY-MM-DD HH:mm:ss"),
      startDt: moment(newStart).format("YYYY-MM-DD HH:mm:ss"),
      end: moment(newEnd).format("YYYY-MM-DD HH:mm:ss"),
      endDt: moment(newEnd).format("YYYY-MM-DD HH:mm:ss"),
      mberNo: user.mberNo,
      beforeScheduleNo: event.scheduleNo,
      managerNo: isPersonal ? null : eventInfo.managerNo,
      managerNm: isPersonal ? null : eventInfo.managerNm,
      workerList: isPersonal ? null : eventInfo.workerList,
    };

    navigate("/mypage/scheduler/form", {
      state: {
        eventInfo: body,
        comments,
        todoInfo: flag
          ? todos.map((todo) => ({
              id: null,
              value: todo.content?.replace(/^[\uffff￿\s]+/, "") || "",
              mentionUserIds:
                todo.mentions.length > 0
                  ? todo.mentions.map((mention) => mention.mberNo.toString())
                  : [],
              showBullet: todo.id ? true : false,
              isChecked: todo.isCompleted,
            }))
          : null,
        isComment: comments.length > 0,
        infoState: "copy",
        navState: { ...(location?.state || {}) },
      },
    });
  };

  //일정 완료
  const eventComplete = async (state) => {
    const url = "/api/schedule";
    const body = keysToRemove(eventInfo);

    body.completeYn = eventInfo.completeYn !== "Y" ? "Y" : "N";
    body.createMberId = user.mberNo;

    const res = await axios.put(url, body);
    if (res.status === 200) {
      getEvent();
      setEventInfo({ ...eventInfo, completeYn: state });
    }
  };

  const handleButtonClick = () => {
    if (active === 4) return setActive(1);
    if (active > 0) return setActive(0);

    navigation("/mypage/scheduler");
  };

  const shareEvent = async (event, templateId) => {
    const url = "/etc/encrypt";
    const body = {
      scheduleNo: event.scheduleNo,
    };

    const res = await axios.post(url, body);
    if (res.status === 200) {
      window.Kakao.Share.sendCustom({
        templateId: templateId,
        templateArgs: {
          key: eventInfo.title,
          scheduleNo: res.data.encrypted,
        },
      });
    }
  };

  return (
    <DetailInfoContaienr className={isDarkMode}>
      <button onClick={handleButtonClick}>
        {active > 0 ? <RiArrowGoBackFill /> : <AiOutlineClose />}
      </button>
      <span>일정 상세보기</span>
      <div className="actions">
        {active === 1 && (
          <button onClick={() => shareEvent(eventInfo, 117645)}>
            <RiShareBoxFill />
          </button>
        )}
        {active === 0 && (
          <button onClick={() => setIsContext(true)}>
            <IoIosMore />
          </button>
        )}
        {isContext && (
          <ul ref={contextRef} className="context">
            {context
              .filter((item) => item.render)
              .map((item, index) => (
                <li key={index} onClick={item.action}>
                  {item.name}
                </li>
              ))}
          </ul>
        )}
      </div>
    </DetailInfoContaienr>
  );
};

export default Info;
